// Persisted "already subscribed to newsletter" flag.
//
// Lets us swap the newsletter form for a more useful tile (sponsor or app
// cross-promo) on subsequent visits so we stop wasting prime real estate
// on a form the user already submitted.

const KEY = 'vibana_newsletter_subscribed_v1';

export function isNewsletterSubscribed() {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function markNewsletterSubscribed() {
  try {
    localStorage.setItem(KEY, '1');
  } catch {}
}

export function clearNewsletterSubscribed() {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}
